export default __webpack_public_path__ + "static/media/4.e5e96a3a.jpg";